import { Component, OnInit } from '@angular/core';
import { MessagesService } from '../messages/messages.service';
import { SwabSample } from '../swab-sample/models/swabSample';
import { ErrorHandler } from '../utils/error-handler';
import { Client } from '../swab-sample/models/client';
import { SelectableLab } from '../carrier/selectable-lab';
import { SwabSampleService } from '../swab-sample/swab-sample.service';
import { SwabSamplePlate } from './models/swabSamplePlate';
import { SwabByPosition } from './models/swabByPosition';

@Component({
    selector: 'app-swab-sample-reception',
    templateUrl: './swab-sample-reception.component.html',
    styleUrls: ['./swab-sample-reception.component.css']
  })

  /**
   * @description Component for the SwabSample reception
   */
  export class SwabSampleReceptionComponent implements OnInit {

    selectedLab: SelectableLab;
    plateID: string;
    allowedClients: Client[];
    selectedClients: Client[] = [];
    swabSamplePlate: SwabSamplePlate;
    swabSamples: SwabSample[] = [];
    cellSavedState: string;
    errorHandler: ErrorHandler = new ErrorHandler;

    constructor(private messageService: MessagesService, private swabSampleService: SwabSampleService) { 
      this.allowedClients = [
        {name:'WisdomHealth', code:'MARVEL_WISDOMHEALTH'},
        {name:'Genoscoper', code:'MARVEL_GENOSCOPER'},
        {name:'Mudho', code:'MARVEL_MUDHO'},
        {name:'IAMYIAM', code:'MARVEL_IAMYIAM'}
      ]
    }

    ngOnInit() {
      this.selectedLab = JSON.parse(localStorage.getItem('lab'));   
    }

    /**
     * @description unselects other options. Wisdomhealth & Genoscoper are allowed together
     * @param option 
     */
    unselectInappropiateOptions(option) {
      let updatedArray = [];
      switch (option) {
        case 'MARVEL_WISDOMHEALTH':
        this.allowedClients.forEach(client => {
          if (client.code == 'MARVEL_WISDOMHEALTH' || client.code == 'MARVEL_GENOSCOPER') {
            updatedArray.push(client);
          }
        });
        break;
        case 'MARVEL_GENOSCOPER':
        this.allowedClients.forEach(client => {
          if (client.code == 'MARVEL_GENOSCOPER' || client.code == 'MARVEL_WISDOMHEALTH') {
            updatedArray.push(client);
          }
        });
        break;
        case 'MARVEL_MUDHO':
        this.allowedClients.forEach(client => {
          if (client.code == 'MARVEL_MUDHO') {
            updatedArray.push(client);
          }
        });
        break;
        case 'MARVEL_IAMYIAM':
        this.allowedClients.forEach(client => {
          if (client.code == 'MARVEL_IAMYIAM') {
            updatedArray.push(client);
          }
        });
        break;
      }
      this.selectedClients = updatedArray;
    }

    /**
     * @description initiates the rows with empty samples
     * @param letter 
     */
    initiateRow(letter: string) {
      for (var i = 0; i < 12; i++) {
        let swabSample: SwabSample = {"positionInPlate": letter + (i+1), "sampleBarCode": "", "qcCheck": null, "petName":null, "petGender":null, "orderItemId":null, "activationDate":null, "lab": null, "plateID": null, "storageID": null, "comments": null, "awbTracking": null, "receivedDate": null, "index": null, "clientId": null };
        this.swabSamples.push(swabSample);
      }
    }

    /**
     * @description checks the allowed client
     * @param swabRow 
     * @param swabByPosition 
     */
    clientCheck(swabRow: HTMLElement, swabByPosition: SwabByPosition) {
      let currentBarcodeInput: HTMLElement;
      let nextBarcodeInput: HTMLElement;
      //Parameter is given when enter is pressed
      if (swabRow) {
        currentBarcodeInput = <HTMLElement> swabRow.children[1];
        nextBarcodeInput = <HTMLElement> swabRow.nextElementSibling.children[1];
      }
      //On enter, go to next row
      if (nextBarcodeInput) {
        setTimeout(function(){
          nextBarcodeInput.click(); 
        }, 70);  
      }
      //Check if input is empty
      if (!swabByPosition.swab.sampleBarCode || swabByPosition.swab.sampleBarCode == '') {
        currentBarcodeInput.style.backgroundColor = "";
        return;
      }
      //Check if a client is chosen
      let allowedClient = false;
      if (!this.selectedClients || this.selectedClients.length <= 0) {
        this.messageService.addWarningMessage({ severity: 'warning', summary: 'Client not chosen', detail: 'Please choose a client.' });
        setTimeout(function(){
          let element = <HTMLElement> document.getElementById('client-select').children[0];
          element.click();
        }, 70); 
        return;
      }
      this.swabSampleService.getSwabSample(this.selectedLab.lab, swabByPosition.swab.sampleBarCode).subscribe(
        results => {
          if (results && results.data) {
            //Check for matching plateID
            if (results.data.plateID && results.data.plateID != null && results.data.plateID != '' && results.data.plateID != this.plateID) {
              currentBarcodeInput.style.backgroundColor = "red";
              this.messageService.addErrorMessage({ severity: 'error', summary: 'Sample not allowed on plate', detail: 'This sample is already on another plate.' });
              return;
            }
            //Check if position is free
            if (this.cellSavedState && this.cellSavedState != '' && this.cellSavedState != results.data.sampleBarCode) {
              this.swabSampleService.getSwabSample(this.selectedLab.lab, this.cellSavedState).subscribe(
                swabResults => {
                  if (swabResults && swabResults.data) {
                    document.getElementById("barcode" + swabResults.data.positionInPlate).parentElement.style.backgroundColor = "";
                    document.getElementById("qcCheck" + swabResults.data.positionInPlate).parentElement.style.backgroundColor = "";
                    swabResults.data.positionInPlate = '';
                    swabResults.data.plateID = '';
                    swabResults.data.qcCheck = '';
                    this.swabSampleService.updateSwabSample(swabResults.data).subscribe(
                      internalResults => {
                        console.log(internalResults);
                      },
                      error => {
                        currentBarcodeInput.style.backgroundColor = "red";
                        let message = this.errorHandler.handleError(error);
                        this.messageService.addErrorMessage(message);        
                      }
                    );
                  }
                },
                error => {
                  currentBarcodeInput.style.backgroundColor = "red";
                  let message = this.errorHandler.handleError(error);
                  this.messageService.addErrorMessage(message);        
                }
              );
            }
            //Check if sample is in another position
            for (let swab of this.swabSamples) {
              if (swab.sampleBarCode == results.data.sampleBarCode && swab.positionInPlate != swabByPosition.position) {
                for (let swabsByPosition of this.swabSamplePlate.swabsByPosition) {
                  if (swabsByPosition.swab.sampleBarCode == results.data.sampleBarCode && swabsByPosition.position != swabByPosition.position) {
                    document.getElementById("barcode" + swabsByPosition.position).parentElement.style.backgroundColor = "";
                    this.swabSamplePlate.swabsByPosition[this.swabSamplePlate.swabsByPosition.indexOf(swabsByPosition)].swab = new SwabSample;
                    break;
                  }
                }
                this.swabSamples.splice(this.swabSamples.indexOf(swab), 1);
                this.messageService.addWarningMessage({ severity: 'warning', summary: 'Swab moved to new position', detail: "Sample '" + swabByPosition.swab.sampleBarCode + "' was moved from '" + swab.positionInPlate + "' to '" + swabByPosition.position + "'"});
                break;
              }
            }            
            //Check if sample matches client selection
            for (let client of this.selectedClients) {
              if (client.code == results.data.clientId) {
                allowedClient = true;
                break;
              }
            }
            //Update sample
            if (allowedClient) {
              if (results.data.plateID == swabByPosition.swab.plateID && results.data.positionInPlate == swabByPosition.position) {
                currentBarcodeInput.style.backgroundColor = "green";
              } else {
                results.data.positionInPlate = swabByPosition.position
                results.data.plateID = this.plateID;
                results.data.qcCheck = '';
                results.data.receivedDate = new Date().toISOString();
                this.swabSampleService.updateSwabSample(results.data).subscribe(
                  internalResults => {
                    console.log(internalResults)
                    currentBarcodeInput.style.backgroundColor = "green";
                  },
                  error => {
                    currentBarcodeInput.style.backgroundColor = "red";
                    let message = this.errorHandler.handleError(error);
                    this.messageService.addErrorMessage(message);        
                  }
                );
              }
              this.swabSamples.push(results.data);
              swabByPosition.swab = results.data;
            } else {
              currentBarcodeInput.style.backgroundColor = "red";
              this.messageService.addErrorMessage({ severity: 'error', summary: 'Barcode not allowed', detail: 'This barcode belongs to another client.' });
            } 
          } else {
            currentBarcodeInput.style.backgroundColor = "red";
            this.messageService.addErrorMessage({ severity: 'error', summary: 'Barcode does not exist', detail: 'This barcode does not exist in the database' });
          }
        },
        error => {
          currentBarcodeInput.style.backgroundColor = "red";
          let message = this.errorHandler.handleError(error);
          this.messageService.addErrorMessage(message);        
        }
      );
    }

    /**
     * @description quality check for sample, checks if 
     * @param swabRow 
     * @param swabByPosition 
     */
    qcCheck(swabRow: HTMLElement, swabByPosition: SwabByPosition) {
      let currentQCCheckInput: HTMLElement;
      let nextQCCheckInput: HTMLElement;
      if (swabRow) {
        currentQCCheckInput = <HTMLElement> swabRow.children[2];
        nextQCCheckInput = <HTMLElement> swabRow.nextElementSibling.children[2];
      }
       //On enter, go to next row
      if (nextQCCheckInput) {
        setTimeout(function(){
          nextQCCheckInput.click(); 
        }, 70);  
      }
      if (!swabByPosition.swab.sampleBarCode || swabByPosition.swab.sampleBarCode == '' || !swabByPosition.swab.qcCheck || swabByPosition.swab.qcCheck == '') {
        currentQCCheckInput.style.backgroundColor = "";
        return;
      }
      if (swabByPosition.swab.sampleBarCode == swabByPosition.swab.qcCheck) {
        this.swabSampleService.getSwabSample(this.selectedLab.lab, swabByPosition.swab.sampleBarCode).subscribe(
          results => {
            results.data.qcCheck = swabByPosition.swab.qcCheck;
            this.swabSampleService.updateSwabSample(results.data).subscribe(
              internalResults => {
                swabByPosition.swab = internalResults.data;
                currentQCCheckInput.style.backgroundColor = "green";
              },
              error => {
                let message = this.errorHandler.handleError(error);
                this.messageService.addErrorMessage(message); 
                currentQCCheckInput.style.backgroundColor = "red";       
              }
            );
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this.messageService.addErrorMessage(message); 
            currentQCCheckInput.style.backgroundColor = "red";  
          }
        );
      } else {
        this.messageService.addErrorMessage({ severity: 'error', summary: 'QCCheck Failed', detail: 'Barcodes do not match' });
        currentQCCheckInput.style.backgroundColor = "red"
      }
    }

    /**
     * @description gets all samples upon entering a plateID in the search
     */
    getSamplesByPlateId() {
      if (this.plateID != "" && this.plateID != null) {
      this.swabSampleService.getSwabSamplesByPlateId(this.selectedLab.lab, this.plateID).subscribe(
        results => {
          if (!results) {
           return;
          }
          this.swabSamplePlate = new SwabSamplePlate;
          this.swabSamples = results.data
          if (this.swabSamples.length > 0) {
            if (this.swabSamples[0].clientId == 'MARVEL_WISDOMHEALTH' || this.swabSamples[0].clientId == 'MARVEL_GENOSCOPER') {
              this.unselectInappropiateOptions('MARVEL_WISDOMHEALTH');
              this.unselectInappropiateOptions('MARVEL_GENOSCOPER');
            } else if (this.swabSamples[0].clientId == 'MARVEL_MUDHO') {
              this.unselectInappropiateOptions('MARVEL_MUDHO');
            } else if (this.swabSamples[0].clientId == 'MARVEL_IAMYIAM') {
              this.unselectInappropiateOptions('MARVEL_IAMYIAM');
            }
          }
          this.placeSwabsInPlatePosition();
        },
        error => {
          let message = this.errorHandler.handleError(error);
          this.messageService.addErrorMessage(message);        
        }
      );
     }
    }

    /**
     * @description places the swab sample in the plate position
     */
    placeSwabsInPlatePosition() {
      this.swabSamples.forEach(swabSample => {
        this.swabSamplePlate.addSwabToPosition(swabSample, swabSample.positionInPlate);
      });
    }

    /**
     * @description saves the state of the editable cell
     * @param state 
     */
    saveState(state:string) {
      this.cellSavedState = state;
    }

  }